import React from 'react'
import { Compass, LineChart, Building2, Activity } from 'lucide-react'
import { formatPercent } from '../utils/format'
import { toneColor } from '../utils/tone'

export default function HouseView({ houseView }) {
  if (!houseView) return null

  return (
    <div className="onds-card p-5 md:p-6">
      <div className="flex items-center gap-2 mb-1">
        <Compass className="h-5 w-5" style={{ color: 'var(--onds-accent)' }} />
        <h2 className="text-lg font-bold">House View</h2>
      </div>
      <p className="text-sm font-medium mb-5" style={{ color: 'var(--onds-text)' }}>{houseView.summary}</p>

      <div className="mb-5">
        <div className="flex justify-between text-xs mb-1.5">
          <span className="font-semibold" style={{ color: 'var(--onds-accent)' }}>Fundamental {formatPercent(houseView.fundamentalWeight, 0)}</span>
          <span className="text-[var(--onds-text-dim)]">Technical {formatPercent(houseView.technicalWeight, 0)}</span>
        </div>
        <div className="h-2.5 rounded-full overflow-hidden flex" style={{ backgroundColor: 'var(--onds-border)' }}>
          <div className="h-full" style={{ width: `${houseView.fundamentalWeight * 100}%`, backgroundColor: 'var(--onds-accent)' }} />
          <div className="h-full" style={{ width: `${houseView.technicalWeight * 100}%`, backgroundColor: 'var(--onds-neutral)' }} />
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <Block iconNode={<Building2 className="h-4 w-4" style={{ color: 'var(--onds-accent)' }} />} title="Fundamental (primary)" text={houseView.fundamental} accent="var(--onds-accent)" />
        <Block iconNode={<LineChart className="h-4 w-4" style={{ color: 'var(--onds-neutral)' }} />} title="Technical (secondary)" text={houseView.technical} accent="var(--onds-neutral)" />
        <Block iconNode={<Activity className="h-4 w-4" style={{ color: 'var(--onds-bull)' }} />} title="Price Action" text={houseView.priceAction} accent="var(--onds-bull)" />
      </div>

      <div className="mt-5 flex items-center justify-between rounded-xl p-3" style={{ backgroundColor: 'var(--onds-surface)' }}>
        <span className="text-sm text-[var(--onds-text-dim)]">Conviction in the business</span>
        <span className="text-lg font-bold tabular-nums" style={{ color: toneColor(houseView.businessConviction >= 0.66 ? 'bull' : 'caution') }}>
          {formatPercent(houseView.businessConviction, 0)}
        </span>
      </div>
    </div>
  )
}

function Block({ iconNode, title, text, accent }) {
  return (
    <div className="rounded-xl p-3" style={{ backgroundColor: 'var(--onds-surface)', borderLeft: `3px solid ${accent}` }}>
      <div className="flex items-center gap-2 mb-1">
        {iconNode}
        <span className="text-sm font-semibold">{title}</span>
      </div>
      <p className="text-sm text-[var(--onds-text-dim)] leading-relaxed">{text}</p>
    </div>
  )
}
